export const StakingABI = {
  abi: [
    {
      inputs: [
        { internalType: "address", name: "_signer", type: "address" },
        { internalType: "address", name: "_contractOwner", type: "address" },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "lendingId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "msgsender",
          type: "address",
        },
      ],
      name: "Borrowed",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "lendingId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "borrower",
          type: "address",
        },
      ],
      name: "Claimed",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "msgsender",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "EOA",
          type: "address",
        },
        {
          indexed: false,
          internalType: "string",
          name: "encrypted",
          type: "string",
        },
      ],
      name: "EOAVerified",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "lendingId",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "address",
          name: "nft",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "tokenid",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "lendAmount",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "borrower",
          type: "address",
        },
        {
          indexed: false,
          internalType: "address",
          name: "rewardToken",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "split",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "address",
          name: "adapter",
          type: "address",
        },
      ],
      name: "Lent",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Paused",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "lendingId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "msgsender",
          type: "address",
        },
      ],
      name: "Unlended",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Unpaused",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "uint256",
          name: "lendingId",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "address",
          name: "borrower",
          type: "address",
        },
      ],
      name: "Withdrawn",
      type: "event",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_lendingId", type: "uint256[]" },
      ],
      name: "borrow",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "EOA", type: "address" }],
      name: "checkEOAVerifed",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_lendingId", type: "uint256[]" },
      ],
      name: "emergencyWithdraw",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "_nft", type: "address" }],
      name: "is1155",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "_nft", type: "address" }],
      name: "is721",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          components: [
            { internalType: "address", name: "borrower", type: "address" },
            { internalType: "address", name: "nft", type: "address" },
            { internalType: "uint96", name: "lendAmount", type: "uint96" },
            { internalType: "uint256", name: "tokenId", type: "uint256" },
            { internalType: "uint256", name: "split", type: "uint256" },
            { internalType: "address", name: "rewardToken", type: "address" },
            { internalType: "address", name: "adapter", type: "address" },
          ],
          internalType: "struct IGuildHub.DirectLendRequest[]",
          name: "data",
          type: "tuple[]",
        },
      ],
      name: "lend",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "", type: "address" },
        { internalType: "address", name: "", type: "address" },
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "bytes", name: "", type: "bytes" },
      ],
      name: "onERC1155Received",
      outputs: [{ internalType: "bytes4", name: "", type: "bytes4" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "", type: "address" },
        { internalType: "address", name: "", type: "address" },
        { internalType: "uint256", name: "", type: "uint256" },
        { internalType: "bytes", name: "", type: "bytes" },
      ],
      name: "onERC721Received",
      outputs: [{ internalType: "bytes4", name: "", type: "bytes4" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "pause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "paused",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256[]", name: "_lendingId", type: "uint256[]" },
      ],
      name: "unLend",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "unpause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          components: [
            { internalType: "address", name: "borrower", type: "address" },
            { internalType: "address", name: "nft", type: "address" },
            { internalType: "uint96", name: "lendAmount", type: "uint96" },
            { internalType: "uint256", name: "tokenId", type: "uint256" },
            { internalType: "uint256", name: "split", type: "uint256" },
            { internalType: "address", name: "rewardToken", type: "address" },
            { internalType: "address", name: "adapter", type: "address" },
          ],
          internalType: "struct IGuildHub.DirectLendRequest[]",
          name: "data",
          type: "tuple[]",
        },
        { internalType: "bytes[]", name: "sig", type: "bytes[]" },
        { internalType: "string[]", name: "key", type: "string[]" },
      ],
      name: "verifyAndLend",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "EOA", type: "address" },
        { internalType: "bytes", name: "signature", type: "bytes" },
        { internalType: "string", name: "encryptedKey", type: "string" },
      ],
      name: "verifyEOA",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ],
};
